module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-72x72-9579ef1b12e214efada0fcd9e1d3f096.png";